export default __webpack_public_path__ + "static/media/photo16.95f98f04.jpg";